<template>
  <div v-if="!isAllow">
    UnAuthorized Access
  </div>
  <div v-else>
    <router-view />
    <el-card shadow="never" style="padding-bottom: 10px">
      <el-col :xs="12" :sm="12" :md="12" :lg="4" style="padding-top: 6pt">
        <span class="head-title" >Manage Deductions ( {{ aStatusLabel }} )</span>
        <div v-if="roleACC" class="deduct-switch">
          <el-switch
            v-model="viewswitch"
            style="display: block"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Personnel"
            inactive-text="Deduction"
            size="small"
          />
        </div>
      </el-col>
      <el-col v-if="viewswitch === true" :xs="24" :sm="24" :md="8" :lg="6">
        <span><el-input v-debounce="getAll" :debounce-events="'keydown'" v-model="search" type="text" placeholder="search" ><i slot="suffix" class="el-input__icon el-icon-search"/></el-input></span>
      </el-col>
      <el-col v-if="viewswitch === true" :xs="24" :sm="24" :md="8" :lg="4">
        <el-select v-model="filtervalue" placeholder="Filter by" @change="filterby($event)">
          <el-option
            v-for="item in lessPayData"
            :key="item.amount"
            :label="item.description"
            :value="item.amount"/>
        </el-select>
      </el-col>
      <!--el-col v-if="viewswitch === true" :xs="24" :sm="24" :md="8" :lg="4">
        <el-select v-model="tenure" placeholder="Sort by" @change="getAll">
          <el-option
            v-for="item in appointStatus"
            :key="item.id"
            :label="item.label"
            :value="item.id"/>
        </el-select>
      </el-col-->
      <!--div v-if="viewswitch === true" style="float: right; ">
        <div v-if="roleACC" style="float: right; ">
          <span style="padding-right: 5px"><el-button type="success" @click="updateWithholding"><i class="el-icon-document" />Calculate withholding tax</el-button></span>
        </div>
      </div-->
    </el-card>
    <el-row v-if="viewswitch === true">
      <el-col :xs="24" :sm="24" :md="8" :lg="9">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-alert
              :closable="false"
              title="Info"
              type="info"
              description="Select an employee to view and manage deductions."
              show-icon />
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="personnel"
            :cell-class-name="setclass"
            :row-class-name="setrowclass"
            :header-cell-class-name="setheadclass"
            element-loading-text="Gathering data..."
            highlight-current-row
            height="520pt"
            style="width: 100%"
            @current-change="handleCurrentChange">
            <el-table-column fixed prop="person_info.fullname" label="Fullname" width="220em"/>
            <el-table-column label="Salary" width="130em">
              <template slot-scope="scope">
                {{ Number(scope.row.salary).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <el-table-column label="Deductions" width="130em">
              <template slot-scope="scope">
                {{ Number(scope.row.total).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <el-table-column label="Net Pay" width="130em" >
              <template slot-scope="scope">
                {{ Number(scope.row.net_pay).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="7" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="24" :md="15" :lg="15">
        <el-row>
          <el-col :xs="24" :sm="24" :md="10" :lg="10">
            <el-card class="box-card" style="min-height: 20em">
              <div slot="header" class="clearfix">
                <el-alert
                  :closable="false"
                  title="Info"
                  type="info"
                  description="Add and update deduction here."
                  show-icon />
              </div>
              <el-form v-loading="loading" ref="form" :model="form" :rules="formRules" element-loading-text="Gathering data..." size="small" auto-complete="on" label-width="100px">
                <el-form-item label="Deduction" prop="deduction_id">
                  <select-deduction :disable="deductionupdate" :deduct="deduction" :key="sel" @setDeduction="setDeduction(form.deduction_id = $event)"/>
                </el-form-item>
                <el-form-item label="Duration" prop="startdate">
                  <el-col :span="11">
                    <el-date-picker v-model="form.startdate" type="date" placeholder="Start date" style="width: 100%;" />
                  </el-col>
                  <el-col :span="2" class="line" style="text-align: center">-</el-col>
                  <el-col :span="11">
                    <el-date-picker v-model="form.enddate" :picker-options="enddate_option" type="date" placeholder="End date" style="width: 100%;" />
                  </el-col>
                </el-form-item>
                <el-form-item label="Amount" prop="amount">
                  <el-input v-model="form.amount" class="amount" type="number"/>
                </el-form-item>
              </el-form>
              <span>
                <span v-if="selected">
                  <el-button v-if="form.personnel_id === ''" type="success" size="small" @click="save">Add</el-button>
                  <el-button v-if="form.personnel_id !== ''" type="success" size="small" @click="save">Update</el-button>
                  <span>
                    <el-button v-if="form.personnel_id !== ''" type="default" size="small" @click="clearForm">Clear</el-button>
                  </span>
                </span>
                <span v-if="applytoall && !selected">
                  <el-button v-if="form.personnel_id === ''" type="success" size="small" @click="updateall">Update all</el-button>
                </span>

              </span>
              <span v-if="applytoall && !selected" style="float: right">
                <el-switch
                  v-model="value"
                  style="display: block"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  inactive-text="All Personnel"
                  @change="applyAll"/>
              </span>
            </el-card>
          </el-col>
          <el-col :xs="24" :sm="24" :md="14" :lg="14">
            <summary-total v-if="selected" :key="key" :personnel="selected"/>
          </el-col>
        </el-row>
        <div v-if="selected" :key="viewswitch">
          <list-deduction ref="ListDeduction" :key="key" :personnel="selected" @key="key++" @active="setActiveDeduction(total = $event)" @update="update( deductdata = $event)"/>
        </div>
      </el-col>
    </el-row>
    <el-row v-else>
      <deduction-view/>
    </el-row>
  </div>
</template>

<script>
import { Personnel } from '@/api/payroll/personnel'
import { EmpDeduction } from '@/api/payroll/empdeduction'
import ListDeduction from './listdeduction'
import SummaryTotal from '../summary/index'
import DeductionView from './deduction-view'
import { NotifySuccess, NotifyWarning } from '../../../helper/Helper'
import SelectDeduction from '../../../views/layout/components/SelectDeduction'
import moment from 'moment'
import _ from 'lodash'
import { Deduction } from '../../../api/payroll/deduction'
export default {
  name: 'PersonnelDeduction',
  components: {
    ListDeduction,
    SelectDeduction,
    SummaryTotal,
    DeductionView
  },
  data() {
    return {
      tenure: parseInt(this.$store.getters.APStatus),
      appointStatus: [
        { label: 'Permanent', id: null },
        { label: 'Contractual', id: 2 },
        { label: 'Casual', id: 1 }
      ],
      meta: {
        page: 1
      },
      options: [{
        value: 'all',
        label: 'All'
      }, {
        value: 'below_5k',
        label: 'Less 5 thousand'
      }],
      form: {
        personnel_id: '',
        active: true,
        deduction_id: '',
        startdate: '',
        enddate: '',
        amount: ''
      },
      viewswitch: true,
      applyAll: false,
      applytoall: false,
      formRules: {
        deduction_id: [{ required: true, message: 'Deduction is required', trigger: 'blur' }],
        // startdate: [{ required: true, message: 'Start date is required', trigger: 'blur' }],
        amount: [{ required: true, message: 'Amount number is required', trigger: 'blur' }]
      },
      filterBy: null,
      filtervalue: '',
      loading: false,
      deduction: {},
      personnel: [],
      search: '',
      selected: null,
      deductionupdate: false,
      value: false,
      listIndex: 0,
      key: 0,
      sel: 0,
      roleACC: false,
      lessPayData: [],
      enddate_option: {
        disabledDate: (date) => {
          if (this.form.startdate !== null) {
            return date.getTime() < this.form.startdate
          }
        }
      },
      aStatusLabel: null,
      campus_id: this.$store.getters.user.currentUser.personnel.department.campus_id,
      isAllow: false
    }
  },
  watch: {
    deduction: function() {
      return this.deduction
    }
  },
  created() {
    this.$store.dispatch('APStatus', this.$store.getters.APStatus)
    if (this.tenure === 3) { this.aStatusLabel = 'Permanent' }
    if (this.tenure === 2) { this.aStatusLabel = 'Contractual' }
    if (this.tenure === 1) { this.aStatusLabel = 'Casual' }
    for (var i = 0; i < this.$store.getters.roles.length; i++) {
      var new_array = Object.entries(this.$store.getters.roles[i])
      for (var key = 0; key < new_array.length; key++) {
        if ((new_array[key][1] === ('payroll_accounting') && this.tenure === 3) || new_array[key][1] === ('payroll_staff') && (this.tenure === 3 || this.tenure === 2 || this.tenure === 1)) {
          // console.log(new_array[key][1])
          this.isAllow = true
          this.checkRole()
          this.getLessPay()
          this.getAll()
          var self = this
          document.onkeydown = function(e) {
            var key = window.event.keyCode
            if (key === 38 && self.index > 0) {
              self.index -= 1
              self.setCurrent(self.index)
            }
            if (key === 40 && self.index < 11) {
              self.index += 1
              self.setCurrent(self.index)
            }
          }
        }
      }
    }
  },
  methods: {
    getLessPay() {
      EmpDeduction({}, 'get', 'getActiveLessPay').then(res => {
        this.lessPayData = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    checkRole() {
      var self = this
      this.$store.getters.user.currentUser.roles.forEach(function(value, key) {
        if (value.name === 'payroll_accounting') {
          self.roleACC = true
        }
      })
    },
    clearForm() {
      this.deduction = null
      this.deductionupdate = false
      this.form = {
        personnel_id: '',
        active: true,
        deduction_id: '',
        startdate: '',
        enddate: '',
        amount: ''
      }
      this.sel++
    },
    // changeview() {
    //   console.log(this.viewswitch)
    // },
    filterby(filter) {
      this.filterBy = filter
      this.getAll()
    },
    setCurrent(row) {
      this.selected = this.$refs.multipleTable.setCurrentRow(this.personnel[row])
    },
    setActiveDeduction(total) {
      this.personnel[this.listIndex].total = total
      this.personnel[this.listIndex].net_pay = (this.personnel[this.listIndex].salary - total) + parseFloat(this.personnel[this.listIndex].ben_total)
    },
    saveUpdate() {
      // console.log(this.form)
    },
    update(data) {
      this.deduction = data.ref_deduction
      this.deductionupdate = true
      this.form = {
        id: data.id,
        personnel_id: data.personnel_id,
        active: true,
        deduction_id: data.deduction_id,
        detail_id: data.deduction_details.id,
        startdate: data.deduction_details.startdate,
        enddate: data.deduction_details.enddate,
        amount: data.deduction_details.amount
      }
      this.setDeduction(data.deduction_id)
    },
    updateall() {
      EmpDeduction({ deduct_id: 23, tenure: this.tenure }, 'post', 'update-all').then(res => {
        if (res.data.message === 'success') {
          NotifySuccess('LRP Deduction is Successfully Updated!')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    setDeduction(id) {
      const salary = (this.selected) ? this.selected.salary : null
      const CSSalary = (this.selected) ? this.selected.salary2 : null
      if (id) {
        Deduction({ id: id, salary: salary, astatus_id: this.selected.astatus_id, salary2: CSSalary }, 'get', 'calculate').then(res => {
          if (res.data.amount !== 0) {
            this.form.amount = parseFloat(res.data.amount).toFixed(2)
          }
        }).catch(error => {
          console.log(error)
        })
        console.log(id)
      }
      if (id === 23) {
        this.value = true
        this.applytoall = true
      }
    },
    changeStatus(id, event) {
      Personnel({ id: id, status: event }, 'post', 'change-status').then(res => {
        // console.log(res.data)
      }).catch(error => {
        console.log(error)
      })
    },
    showDeduction(index) {
      this.listIndex = index
      this.clearForm()
      this.key++
      this.selected = Object.assign({}, this.personnel[index])
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          var action = this.form.detail_id ? 'patch' : 'post'
          this.form.personnel_id = this.selected.id
          this.form.startdate = this.form.startdate ? this.getFormattedDate(this.form.startdate) : null
          this.form.enddate = this.form.enddate ? this.getFormattedDate(this.form.enddate) : null
          this.form.active = true
          EmpDeduction(this.form, action, '').then(res => {
            if (res.data.status === 'success') {
              if (action === 'patch') {
                NotifySuccess('Deduction is Successfully Updated!')
              } else {
                NotifySuccess('Deduction is Successfully Added!')
              }
              this.$refs.ListDeduction.getAll()
              this.key++
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    getFormattedDate(date) {
      if (date) return this.$moment(date).format('YYYY-MM-DD')
      return null
    },
    format_date(value) {
      if (value) return moment(String(value)).format('MM/DD/YYYY')
      return '--'
    },
    handleCurrentChange: _.debounce(function(val) {
      if (val) {
        this.index = this.personnel.findIndex(x => x.id === val.id)
        this.currentRow = val
        this.showDeduction(this.index)
        this.sel++
        this.clearForm()
      }
    }, 500),
    updateWithholding: _.debounce(function(val) {
      this.loading = true
      NotifyWarning(`Updating Withholding! Please wait...`)
      EmpDeduction(this.form, 'post', 'set-default-tax').then(res => {
        if (res.data.status === 'success') {
          NotifySuccess('Withholding is Successfully Updated!')
          this.loading = false
        }
      }).catch(error => {
        console.log(error)
      })
    }, 500),
    getAll() {
      this.loading = true
      Personnel({ sort: true, term: this.search, astatus: 'Permanent', lessSalary: this.filterBy, status: null, page: this.meta.page, tenure: this.tenure, campus_id: this.campus_id }, 'get', '').then(res => {
        this.personnel = res.data.personnel
        this.meta = res.data.meta
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    setclass(row) {
      if (row.columnIndex === 1 || row.columnIndex === 2 || row.columnIndex === 3) {
        return 'deduct_cell_' + row.columnIndex
      }
    },
    setrowclass({ row, rowIndex }) {
      var total = Number(row.net_pay)
      if (total < 5000) {
        return 'perosnnel warning-row'
      }
      return 'personnel'
    },
    setheadclass(row) {
      if (row.columnIndex === 1 || row.columnIndex === 2 || row.columnIndex === 3) {
        return 'personnel ' + 'header_' + row.columnIndex
      }
    }
  }
}
</script>

<style lang="scss">
  .amount.el-input{
    .el-input__inner {
      text-align: right;
    }
  }
  .el-table .warning-row {
    background: yellow;
  }
  .el-alert--info {
    background-color: #e1ffd0 !important;
  }
  .deduct_cell_1, .deduct_cell_2, .deduct_cell_3 {
    text-align: right;
    padding-right: 2em !important;
  }
  .header_1, .header_2, .header_3 {
    text-align: center !important;
  }
</style>
